import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { Button, Checkbox, IconButton } from "rsuite";
import { LoadingContext } from "../contexts/LoadingContext";
import { SearchContext } from "../contexts/SearchContext";
import {
  createTag,
  deleteTag,
  getTags,
  updateTag,
} from "../services/inventory/ProductApi";
import { errorToast } from "../utils/helper-ui";
import { PaginationResponse } from "../objects/pagination";
import { getPagination, invertColor } from "../utils/helper";
import { Tag } from "../models/inventory/product";
import { Table, Pagination } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import { BsTrash3 } from "react-icons/bs";
import TagForm from "../components/features/inventory/TagForm";
// import TagForm from "../components/features/inventory/TagForm";
const { Column, HeaderCell, Cell } = Table;
interface TagPageProps {}

const TagPage: FC<TagPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [tags, setTags] = useState<Tag[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedTag, setSelectedTag] = useState<Tag>();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === tags.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < tags.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? tags.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getTags({ page, size, search });
      const resJson = await res.json();
      //   console.log(data);
      setTags((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const removeTag = async (tag: Tag) => {
    try {
      setIsLoading(true);
      if (
        window.confirm(
          `Are you sure you want to delete tag with name ${tag.name}?`
        )
      ) {
        await deleteTag(tag.id!);
        fetchData();
      }
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  const saveTag = async (tag: Tag) => {
    try {
      setIsLoading(true);
      if (selectedTag) {
        await updateTag(selectedTag.id!, tag);
      } else {
        await createTag(tag);
      }
      setModalFormOpen(false);
      setSelectedTag(undefined);
      fetchData();
      setTags([]);
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Tag</h1>
      {/* button */}
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Tag
        </IconButton>
      </div>
    </div>
  );
  return (
    <MainLayout header={renderHeader()}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th
                className="px-4 py-2 text-left border bg-gray-50"
                style={{ width: 100 }}
              >
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>

              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Description
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Icon</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Color</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Action</th>
            </tr>
          </thead>
          <tbody>
            {tags.map((tag, i) => (
              <tr key={tag.id} className="hover:bg-gray-50">
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={tag.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((e) => e === tag.id)}
                  />
                  {i + 1}
                </td>

                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer"
                    onClick={() => {
                      setSelectedTag(tag);
                      setModalFormOpen(true);
                    }}
                  >
                    {tag.name}
                  </div>
                </td>
                <td className="px-4 py-2 border">{tag.description}</td>
                <td className="px-4 py-2 border">
                  {tag.icon_url && (
                    <img
                      src={tag.icon_url}
                      style={{ height: 50 }}
                      alt="icon_url"
                    />
                  )}
                </td>
                <td className="px-4 py-2 border">
                  <div
                    className="rounded-lg w-10 h-10"
                    style={{
                      backgroundColor: tag.color,
                      color: invertColor(tag.color),
                    }}
                  ></div>
                </td>
                <td className="px-4 py-2 border">
                  <BsTrash3
                    className="text-red-500 hover:text-red-800"
                    size={16}
                    onClick={() => removeTag(tag)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={tags} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>{(page - 1) * size + tags.indexOf(rowData as Tag) + 1}</div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  setSelectedTag(rowData as Tag);
                  setModalFormOpen(true);
                }}
              >
                {rowData.name}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Description</HeaderCell>
          <Cell dataKey="description" />
        </Column>

        <Column width={100} resizable>
          <HeaderCell>Icon</HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) =>
              rowData.icon_url && (
                <img
                  src={rowData.icon_url}
                  style={{ height: 50 }}
                  alt="icon_url"
                />
              )
            }
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Color</HeaderCell>
          <Cell style={{ padding: "2px 0px" }}>
            {(rowData) => (
              <div
                className="rounded-lg w-10 h-10 px-2 text-center text-xs !border-gray-300"
                style={{
                  backgroundColor: rowData.color,
                  color: invertColor(rowData.color),
                }}
              ></div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {(rowData) => (
              <BsTrash3
                className="text-red-500 hover:text-red-800"
                size={16}
                onClick={() => removeTag(rowData as Tag)}
              />
            )}
          </Cell>
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div> */}
      <TagForm
        tag={selectedTag}
        open={modalFormOpen}
        onClose={() => {
          setModalFormOpen(false);
          setSelectedTag(undefined);
        }}
        onSubmit={saveTag}
      />
    </MainLayout>
  );
};
export default TagPage;

